import React, { useEffect, useState } from 'react';

import { ModalProvider } from '@/context/ModalProvider';

import { Section } from '@/components/global/Section';

import { TRecommendation } from '@/services/requests/Recommendation/types/template4';

import { getLayoutClass } from '@/helpers/HtmlHelper/getLayoutClass';

import { Layout1 } from './Layout1';
import { Layout2 } from './Layout2';
import { Layout3 } from './Layout3';

type TProps = {
  data: TRecommendation[];
};

type TLayout = '1' | '2' | '3';

export const TemplateVitrine4 = ({ data }: TProps) => {
  const { layout, onboarding } = data[0];
  const [isOnboarding, setIsOnboarding] = useState(false);
  const layoutRenders = {
    '1': () => <Layout1 data={data[0]} setOnboarding={setIsOnboarding} />,
    '2': () => <Layout2 data={data[0]} />,
    '3': () => <Layout3 data={data[0]} />,
  };

  useEffect(() => {
    setIsOnboarding(!!onboarding);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const render = () => {
    if (isOnboarding) {
      return layoutRenders['1']();
    }

    return layoutRenders[layout as TLayout]();
  };

  return (
    <ModalProvider theme="smiles">
      <Section
        className={getLayoutClass('4', isOnboarding ? '1' : layout)}
        data={data}
      >
        <div className="vitrine-template4__container">{render()}</div>
      </Section>
    </ModalProvider>
  );
};
